import _ from 'lodash';
import Container from '@mui/material/Container';
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Could not find a declaration file for module 'request-ip'. '/Users/aaronpierce/workspace/tac-hsiyc-web/node_modules/request-ip/lib/index.js' implicitly has an 'any' type.
import requestIp from 'request-ip';

import Breadcrumbs from '../../../../components/breadcrumbs';
import FeatureTestGrouping from '../../../../components/feature-test-grouping';
import Layout from '../../../../components/layout';
import Scorecard from '../../../../components/scorecard';
import ShareFab from '../../../../components/share-fab';
import ConnectedCardListings from '@/components/similar-but-safer/components/connected-card-listings';
import SimilarButSafer from '@/components/similar-but-safer';
import VehicleDetailHeaderFilter from '../../../../components/vehicle-detail-header-filter';
import { SPACE, BODY_STYLES, RATERS } from '../../../../constants';
import { fetchAncapTestCategories, fetchSafetyFeatureCategories } from '../../../../utils/api';
import {
  extractAncapTestCategories,
  getAncapOverallScoreResult,
  getAncapTestCategoryResult,
  getRelatedAncapTestCategory,
} from '../../../../utils/ancap-record';
import { getRating } from '../../../../utils/get-rating-provider';
import { getIsExpiredAncapRating } from '../../../../utils/logic/expired-ancap';
import { mergeVehicleSafetyFeaturesIntoCategories } from '../../../../utils/safety-features';
import NoResults from '../../../_no-results';
import logger from '../../../../utils/logger';
import setStatusCode from '../../../../utils/set-status-code';
import { withAppProps, withAppProviders } from '../../../../utils/withAppProps';
import { getDefaultVariant } from '../../../../utils/get-default-variant';
import { getVehicleImage } from '../../../../utils/get-vehicle-image';
import { P_PLATE_RESTRICTION_STATUSES } from '../../../../constants/statuses';
import getIsZeroStarAncapRating from '../../../../utils/get-is-zero-star-ancap-rating';
import { validateQueryParameter } from '../../../../utils/validate-query-parameter';
import { getVehicleManufactureYears } from '../../../../utils/apollo-requests/vehicles/get-vehicle-manufacture-years';
import { getVehicleSafetyFeatures } from '../../../../utils/apollo-requests/vehicles/get-vehicle-safety-features';
import { getVehicleAncapTestRecords } from '../../../../utils/apollo-requests/vehicles/get-vehicle-ancap-test-records';
import { getBatchVehicleDerivedFields } from '@/utils/apollo-requests/vehicles/get-batch-vehicle-derived-fields';
import { getBatchVehicleOverrideFields } from '@/utils/apollo-requests/vehicles/get-batch-vehicle-override-fields';
import { getVehicles } from '../../../../utils/apollo-requests/vehicles/get-vehicles';
import { getSaferVariant } from '@/utils/safer-variant/get-safer-variant';
import { getVehicleEcoData } from '@/utils/apollo-requests/vehicles/get-vehicle-eco-data';

const buildScorecardProps = (
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'pageVehicle' implicitly has an 'any' type.
  pageVehicle,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'selectedRating' implicitly has an 'any' type.
  selectedRating,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'recommendedSafetyFeaturesCount' implicitly has an 'any' type.
  recommendedSafetyFeaturesCount,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'ancapTestRecord' implicitly has an 'any' type.
  ancapTestRecord,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'ancapTestResults' implicitly has an 'any' type.
  ancapTestResults,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'shouldUsePedestrianProtection' implicitly has an 'any' type.
  shouldUsePedestrianProtection
) => {
  const vehicleDetails = {
    image: getVehicleImage(pageVehicle),
    ratingProvider: selectedRating.provider,
    redbookCode: pageVehicle.redbookCode,
    stars: selectedRating.rating,
    yearTested: selectedRating.provider === RATERS.ANCAP ? ancapTestRecord.ratingYear : null,
    makeDescription: pageVehicle.makeDescription,
    modelDescription: pageVehicle.modelDescription,
    year: pageVehicle.year,
  };
  const scorecardBaseItems = {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ all: { label: string; imageUrl: string; }; hatch: { label: string; imageUrl: string; }; sedans: { label: string; imageUrl: string; }; suvs: { label: string; imageUrl: string; }; sport: { label: string; imageUrl: string; }; peopleMovers: { ...; }; commercial: { ...; }; }'.
    bodyStyle: BODY_STYLES[pageVehicle.derivedBodyStyle] || '',
    recommendedSafetyFeaturesCount,
  };
  const ucsrTestResults = {
    primarySafety: pageVehicle.ucsrPrimarySafety,
    aggressivity: pageVehicle.ucsrAggressivity,
    driverProtection: pageVehicle.ucsrDriver,
    saferPick: pageVehicle.ucsrSaferPick,
  };
  const footer = {
    newPrice: pageVehicle.newPrice,
    priceRange: { low: pageVehicle.privateMinPrice, high: pageVehicle.privateMaxPrice },
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ REFERRED: { icon: ({ className, ...props }: { [x: string]: any; className: any; }) => Element; status: string; }; BANNED: { icon: ({ className, ...props }: { [x: string]: any; className: any; }) => Element; status: string; }; APPROVED: { ...; }; }'.
    pPlateRestrictions: P_PLATE_RESTRICTION_STATUSES[_.upperCase(pageVehicle.pPlateStatus)],
  };
  return {
    vehicleDetails,
    scorecardBaseItems,
    ancapTestResults,
    ucsrTestResults,
    shouldUsePedestrianProtection,
    footer,
  };
};

const buildFeatureTestGroupingProps = (
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'vehicleSafetyFeatureCategories' implicitly has an 'any' type.
  vehicleSafetyFeatureCategories,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'ancapTestCategories' implicitly has an 'any' type.
  ancapTestCategories,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'shouldUsePedestrianProtection' implicitly has an 'any' type.
  shouldUsePedestrianProtection
) => {
  return _.map(vehicleSafetyFeatureCategories, (safetyFeatureCategory) => ({
    ...safetyFeatureCategory,
    relatedAncapCategory: getRelatedAncapTestCategory(
      safetyFeatureCategory,
      ancapTestCategories,
      shouldUsePedestrianProtection
    ),
  }));
};

const SpaceX2 = styled.div`
  margin-top: ${SPACE.X2};
`;

const SpaceX1 = styled.div`
  margin-top: ${SPACE.X1};
`;

const VehiclePage = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'fullUrl' implicitly has an 'any' type.
  fullUrl,
  statusCode = 200,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'pageVehicle' implicitly has an 'any' type.
  pageVehicle,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'pageVehicles' implicitly has an 'any' type.
  pageVehicles,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'saferVariant' implicitly has an 'any' type.
  saferVariant,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'vehicleYearOptions' implicitly has an 'any' type.
  vehicleYearOptions,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'selectedVehicleYearOption' implicitly has an 'any' type.
  selectedVehicleYearOption,
  ancapTestRecord = null,
  ancapTestResults = null,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'shouldUsePedestrianProtection' implicitly has an 'any' type.
  shouldUsePedestrianProtection,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'recommendedSafetyFeaturesCount' implicitly has an 'any' type.
  recommendedSafetyFeaturesCount,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'selectedRating' implicitly has an 'any' type.
  selectedRating,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'vehicleSafetyFeatureCategories' implicitly has an 'any' type.
  vehicleSafetyFeatureCategories,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'testCategories' implicitly has an 'any' type.
  testCategories,
  overallScore = null,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'vehicleEcoData' implicitly has an 'any' type.
  vehicleEcoData,
}) => {
  if (statusCode !== 200 || _.isNil(pageVehicle)) {
    return <NoResults />;
  }

  const isZeroStarAncapRating = getIsZeroStarAncapRating(pageVehicle);
  const overrideSelectedRating = isZeroStarAncapRating ? { provider: 'ANCAP', rating: 0 } : selectedRating;

  const scorecardProps = buildScorecardProps(
    pageVehicle,
    overrideSelectedRating,
    recommendedSafetyFeaturesCount,
    ancapTestRecord,
    ancapTestResults,
    shouldUsePedestrianProtection
  );
  const featureTestGroupingProps = buildFeatureTestGroupingProps(
    vehicleSafetyFeatureCategories,
    testCategories,
    shouldUsePedestrianProtection
  );

  const { makeDescription, modelDescription } = pageVehicle;
  const title = `${makeDescription} ${modelDescription}`;
  const entryDeep = {
    title,
    ancestors: [{ title: 'Search', url: '/results' }],
  };

  return (
    <Layout>
      <Container maxWidth="xl">
        <SpaceX2 />
        <Breadcrumbs entry={entryDeep} />
        <SpaceX1 />
        <VehicleDetailHeaderFilter
          {...{
            title,
            pageVehicle,
            pageVehicles,
            selectedVehicleYearOption,
            vehicleYearOptions,
            saferVariant,
          }}
        />
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'actions' is missing in type '{ vehicleEcoData: any; pageVehicle: any; vehicleDetails: { image: { src: any; alt: string; }; ratingProvider: any; redbookCode: any; stars: any; yearTested: any; makeDescription: any; modelDescription: any; year: any; }; ... 4 more ...; footer: { ...; }; }' but required in type 'Omit<Pick<{ actions: any; vehicleDetails?: null | undefined; scorecardBaseItems?: null | undefined; ancapTestResults?: null | undefined; ucsrTestResults?: null | undefined; shouldUsePedestrianProtection?: boolean | undefined; footer?: null | undefined; vehicleEcoData: any; pageVehicle: any; }, "footer" | ... 4 more ...'. */}
        <Scorecard {...scorecardProps} vehicleEcoData={vehicleEcoData} pageVehicle={pageVehicle} />
        <SpaceX1 />
        {_.map(featureTestGroupingProps, (grouping) => (
          <FeatureTestGrouping
            key={grouping.id}
            heading={grouping.title}
            ancapTestCategoryResult={getAncapTestCategoryResult(grouping.relatedAncapCategory, !!overallScore)}
            subHeading={grouping.categoryDescription}
            safetyFeatures={grouping.tacSafetyFeatureEntries}
            ratingProvider={overrideSelectedRating.provider}
            relatedAncapCategory={grouping.relatedAncapCategory}
          />
        ))}
      </Container>
      <SpaceX1 />
      <ShareFab {...{ fullUrl }} />
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'ConnectedComponentClass<{ makeDescription: any; modelDescription: any; year: any; hits: any; }, HitsProvided<unknown>, {}>' is not assignable to type '() => null'. */}
      <SimilarButSafer vehicle={pageVehicle} ConnectedComponent={ConnectedCardListings} />
    </Layout>
  );
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'make' implicitly has an 'any' type.
const getServerSideProps = withAppProps(async ({ query: { make, model, year, vehicle }, req, res }) => {
  const isInputValid = validateQueryParameter(make) && validateQueryParameter(model) && validateQueryParameter(year);

  if (!isInputValid) {
    logger.error('Invalid make, model or year entered', {
      make,
      model,
      year,
      userIp: requestIp.getClientIp(req),
      userAgent: req.headers['User-Agent'],
      headers: req.headers,
    });
    return setStatusCode(404, res);
  }

  const [safetyFeatureCategories, ancapTestCategories, pageVehicles, vehicleYears] = await Promise.all([
    fetchSafetyFeatureCategories(),
    fetchAncapTestCategories(),
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type '{ make: any; model: any; year: any; }' is not assignable to parameter of type '{ make: any; model: any; year: any; vehicleIds: any; }'.
    getVehicles({ make, model, year }),
    getVehicleManufactureYears(make, model),
  ]);

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'vehicles' does not exist on type 'string | { vehicles: any; }'.
  const { vehicles, error } = pageVehicles;
  if (error) {
    return setStatusCode(error.status, res);
  }

  if (_.isEmpty(vehicles)) {
    logger.warn('No vehicles found server side for make, model, year', { make, model, year, vehicle }, req);
    return setStatusCode(404, res);
  }

  const pageVehicle = vehicle ? _.find(vehicles, ({ slug }) => slug === vehicle) : getDefaultVariant(vehicles);
  if (_.isNil(pageVehicle)) {
    logger.warn('No specific vehicle found server side for make, model, year', { make, model, year, vehicle }, req);
    return setStatusCode(404, res);
  }

  const { years } = vehicleYears;
  const vehicleYearOptions = _.orderBy(
    _.map(years, (value) => ({ id: value, value })),
    ['value'],
    ['desc']
  );
  const selectedVehicleYearOption =
    _.find(vehicleYearOptions, (option) => option.value === pageVehicle.year) || _.head(vehicleYearOptions);

  const [vehicleSafetyFeatures, ancapTestRecord, vehicleEcoData] = await Promise.all([
    getVehicleSafetyFeatures(pageVehicle.redbookCode),
    getVehicleAncapTestRecords(pageVehicle.redbookCode),
    getVehicleEcoData(pageVehicle.redbookCode),
  ]);

  const vehicleSafetyFeatureCategories = mergeVehicleSafetyFeaturesIntoCategories(
    safetyFeatureCategories,
    vehicleSafetyFeatures
  );
  const recommendedSafetyFeaturesCount = {
    vehicle: pageVehicle.safetyFeaturesLinkedCount,
    total: pageVehicle.totalRecommendedSafetyFeatures,
  };

  const testCategories = extractAncapTestCategories(ancapTestCategories, ancapTestRecord);
  const overallScore = getAncapOverallScoreResult(ancapTestRecord);
  const ancapTestResults = {
    ancapReport: ancapTestRecord.technicalReportUrl || null,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 2 arguments, but got 1.
    adultOccupantProtection: getAncapTestCategoryResult(testCategories.adult),
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 2 arguments, but got 1.
    activeSafetyAssist: getAncapTestCategoryResult(testCategories.safetyAssist),
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 2 arguments, but got 1.
    childOccupantProtection: getAncapTestCategoryResult(testCategories.child),
    overallScore,
    pedestrianProtection: getAncapTestCategoryResult(testCategories.pedestrian, !!overallScore),
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 2 arguments, but got 1.
    vulnerableRoadUserProtection: getAncapTestCategoryResult(testCategories.vulnerableRoadUsers),
    // @TODO: use logic package export once we merge repos
    expired: getIsExpiredAncapRating({ rating: { testYear: ancapTestRecord.ratingYear } }),
  };
  const { vulnerableRoadUserProtection } = ancapTestResults;
  const shouldUsePedestrianProtection = !!overallScore || !vulnerableRoadUserProtection;

  const { selectedRating } = getRating(pageVehicle, ancapTestRecord);

  const saferVariant = await getSaferVariant({
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'vehicles' does not exist on type 'string | { vehicles: any; }'.
    vehicles: pageVehicles.vehicles,
    currentVehicle: pageVehicle,
    ancapTestRecord,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '(vehicleIds: string[]) => Promise<VehicleDerivedFields[] | string>' is not assignable to type '(vehicleIds: string[]) => Promise<VehicleDerivedFields[]>'.
    getBatchDerivedFields: getBatchVehicleDerivedFields,
    getBatchOverrideFields: getBatchVehicleOverrideFields,
  });

  const fullUrl = `https://${req.headers.host}${req.url}`;

  return {
    props: {
      fullUrl,
      pageVehicle,
      pageVehicles,
      vehicleYearOptions,
      selectedVehicleYearOption,
      ancapTestRecord,
      ancapTestResults,
      shouldUsePedestrianProtection,
      recommendedSafetyFeaturesCount,
      selectedRating,
      vehicleSafetyFeatureCategories,
      testCategories,
      overallScore,
      saferVariant,
      vehicleEcoData,
    },
  };
});

const testCategoryShape = {
  categoryDescription: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  slug: PropTypes.string,
  tests: PropTypes.array,
};

const pageVehicleShape = {
  id: PropTypes.string,
  makeDescription: PropTypes.string,
  modelDescription: PropTypes.string,
  redbookCode: PropTypes.string,
  year: PropTypes.string,
  sequenceNumber: PropTypes.number,
  segment: PropTypes.string,
  vehicleDescription: PropTypes.string,
  series: PropTypes.string,
  badgeDescription: PropTypes.string,
  newPrice: PropTypes.number,
  privateMinPrice: PropTypes.number,
  privateMaxPrice: PropTypes.number,
  derivedBodyStyle: PropTypes.string,
  transmission: PropTypes.string,
  linkedSafetyFeaturesCount: PropTypes.number,
  engineDisplacement: PropTypes.string,
  ucsrRating: PropTypes.number,
  ancapRating: PropTypes.number,
  pPlateStatus: PropTypes.string,
  ucsrAggressivity: PropTypes.number,
  ucsrDriver: PropTypes.number,
  ucsrPrimarySafety: PropTypes.number,
  ucsrSaferPick: PropTypes.bool,
  fuelType: PropTypes.string.isRequired,
};

VehiclePage.propTypes = {
  fullUrl: PropTypes.string.isRequired,
  statusCode: PropTypes.number,
  pageVehicle: PropTypes.shape(pageVehicleShape).isRequired,
  vehicleYearOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  selectedVehicleYearOption: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  ancapTestRecord: PropTypes.shape({
    rating: PropTypes.number,
    ratingYear: PropTypes.number,
    technicalReportUrl: PropTypes.string,
    testResults: PropTypes.array,
  }),
  ancapTestResults: PropTypes.shape({
    ancapReport: PropTypes.string,
    adultOccupantProtection: PropTypes.string,
    activeSafetyAssist: PropTypes.string,
    childOccupantProtection: PropTypes.string,
    overallScore: PropTypes.string,
    pedestrianProtection: PropTypes.string,
    vulnerableRoadUserProtection: PropTypes.string,
  }),
  shouldUsePedestrianProtection: PropTypes.bool.isRequired,
  recommendedSafetyFeaturesCount: PropTypes.shape({
    vehicle: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  selectedRating: PropTypes.shape({
    provider: PropTypes.string,
    rating: PropTypes.number,
  }).isRequired,
  vehicleSafetyFeatureCategories: PropTypes.array.isRequired,
  vehicleEcoData: PropTypes.shape({
    powerplanttype: PropTypes.string,
    energyconsumption: PropTypes.number,
    kmrangeelectricwltp: PropTypes.number,
    greenhouserating: PropTypes.number,
    airpollutionrating: PropTypes.number,
    co2combined: PropTypes.number,
    co2urban: PropTypes.number,
    co2extraurban: PropTypes.number,
    fuelcombined: PropTypes.number,
    fuelurban: PropTypes.number,
    fuelextraurban: PropTypes.number,
    emissionstandard: PropTypes.string,
  }),
  testCategories: PropTypes.shape({
    adult: PropTypes.shape(testCategoryShape),
    child: PropTypes.shape(testCategoryShape),
    pedestrian: PropTypes.shape(testCategoryShape),
    vulnerableRoadUsers: PropTypes.shape(testCategoryShape),
    safetyAssist: PropTypes.shape(testCategoryShape),
  }).isRequired,
  overallScore: PropTypes.string,
  saferVariant: PropTypes.shape(pageVehicleShape),
};

export default withAppProviders(VehiclePage);
export { getServerSideProps };
